import {
    hasCurrentUserEvaluatorPrivilege,
    isAiMarkingReadOnly,
} from '../../services/permissions/PermissionService';
import { GradingPartyDocument } from '../../services/gradingPartyService';

export const isAiIntroKnownReadOnly = (gradingPartyDocument?: GradingPartyDocument): boolean => (
    hasCurrentUserEvaluatorPrivilege()
    && !!gradingPartyDocument
    && isAiMarkingReadOnly(gradingPartyDocument)
);

export const shouldHideAiIntroForReadOnly = (gradingPartyDocument?: GradingPartyDocument): boolean => {
    if (!hasCurrentUserEvaluatorPrivilege()) {
        return false;
    }
    if (!gradingPartyDocument) {
        return true;
    }
    return isAiMarkingReadOnly(gradingPartyDocument);
};
